import { useReadableEventRefresher } from '@zdrbm/zdr-react';
import { IPoi } from 'features/explore/model/poi-model/poi';
import { usePoiPresenterFactory } from '../hooks/use-poi-presenter-factory';

export function usePoiAttributes(poi: IPoi) {
    const presenterFactory = usePoiPresenterFactory();
    const [[name], [geolocation], [logoUrl], [type]] = useReadableEventRefresher(
        poi.name,
        poi.geolocation,
        poi.logoUrl,
        poi.type,
    );

    const presenter = poi.selectFromFactory(presenterFactory);

    const shortAddress = presenter.getShortAddress(poi);
    const categoriesBullets = presenter.getCategoriesBullets(poi);

    return {
        badge: poi.getBadgeValue(),
        address: poi.getAddress(),
        name,
        geolocation,
        logoUrl,
        type,
        metrics: poi.getMetrics(),
        shortAddress,
        categoriesBullets,
    };
}
